import { useState } from 'react'
import PasswordForm from "./components/PasswordForm"
import Main from "./components/Main"
import Action from "./components/Action"
import FlashMessage from "./components/FlashMessage"
import StyleSelector from "./components/StyleSelector"
import LanguageSelector from "./components/LanguageSelector"
import MainDoc from "./components/MainDoc"
import languageStorage from "./storage/languageStorage"
import FlashMessageStorage from "./storage/flashMessageStorage"
import masterPasswordStorage from "./storage/masterPassword"
import domainStorage from "./storage/domainStorage"
import { HiOutlineLockClosed, HiOutlineLockOpen, HiOutlineXCircle } from "react-icons/hi";
import favicon from "./utility/favicon"

const flash = new FlashMessageStorage(5000, 1000, true)

function App()
{
    const [lang, setLang] = useState(languageStorage.getLanguage())
    const [masterPassword, setMasterPassword] = useState(masterPasswordStorage())
    languageStorage.setCallback(setLang)
    const realSetMasterPassword = (password, permanent) => {
        setMasterPassword(password)
        masterPasswordStorage(permanent ? password : null)
    }
    favicon.setOpen(masterPassword !== null)
    const logout = () => realSetMasterPassword(null, true)
    var content
    var logoutButton
    if (masterPassword === null) {
        content = <>
            <PasswordForm setPassword={realSetMasterPassword} flash={flash} lang={lang} />
        </>
        logoutButton = <span className="lock login"><HiOutlineLockClosed /></span>
    } else {
        content = <Main masterPassword={masterPassword} flash={flash} lang={lang} />
        logoutButton=<Action action={logout} title={lang.tr("wipe_master_password")} className="lock logout" defaultClass={false}><HiOutlineLockOpen /></Action>
    }
    return <>
        <div className="settings">
            <LanguageSelector flash={flash} lang={lang}/>
            <StyleSelector flash={flash} lang={lang}/>
        </div>
        <FlashMessage flash={flash} lang={lang}/>
        <div className="app">
            {logoutButton}
            <div>
                <h1>singularkey.net</h1>
                <em>{lang.tr("one_key_to_rule_them_all")}</em>
            </div>
            {content}
        </div>
    </>
}

export default App
